<template>
    <div class="page Mixologists"  @scroll="pageScroll" ref="page">
        
        <div class="pageContainer">
            <div class="container">
                <h2 class="d-flex justify-content-between align-items-center mb-4 text-center">
                    <img :src="getStaticImage('icon-arrow-left.png')" @click="$router.go(-1)" alt="back">
                    <span>{{ $t('mixologists.Our Family of Mixologists') }}</span>
                    <span style="width: 35px"></span>
                </h2>
                
                    <div
                        class="list"
                        
                    >
                        <div
                            class="listItem"
                            v-for="m in preloaded.mixologists"
                        >
                                <div class="listIContainer"  @click="goToMixologist(m.id)">
                                    <div class="imgBox">
                                        <img class="img-fluid" :src="m.featured_image ? m.featured_image : getStaticImage('logo.png')"></img>
                                    </div>
                                {{m.name}}
                                </div>
                        </div>
                    </div>
            
            </div>
        </div>
    </div>
</template>

<script>

    import pageMixin from "../mixins/page";

    import {mapState} from "vuex"

    export default {
        name: 'Mixologists',
        mixins: [pageMixin],
        data() {
            return {
                
            }
        },
        methods: {
            goToMixologist(id) {
                this.$router.push({name: "mixologists", query: {...this.$route.query, mixologist: id}})
            }
        },
        created() {
            
        },
        computed: {
            ...mapState("shared", ["preloaded"])
        },

    }
</script>

